import { MarketingPageShell } from "@/components/landing/MarketingPageShell"
import { LegalProse } from "@/components/landing/LegalProse"

export function PrivacyPage() {
  return (
    <MarketingPageShell
      narrow
      eyebrow="Legal"
      title="Privacy policy"
      description="Last updated: November 16, 2025."
      extra="Sqaleshop is committed to protecting your privacy. This policy explains how we collect, use, and safeguard your information."
    >
      <LegalProse>
        <section>
          <h2>1. Information we collect</h2>
          <h3 className="mt-6 font-heading text-base font-semibold text-[#111827]">
            a. Personal information
          </h3>
          <p>We collect information you provide when you create an account, including:</p>
          <ul>
            <li>Name</li>
            <li>Email address</li>
            <li>Phone number</li>
            <li>Business details</li>
          </ul>
          <h3 className="mt-6 font-heading text-base font-semibold text-[#111827]">
            b. Store and product information
          </h3>
          <p>Details about your store, product listings, pricing, and settings.</p>
          <h3 className="mt-6 font-heading text-base font-semibold text-[#111827]">
            c. Usage data
          </h3>
          <p>Such as:</p>
          <ul>
            <li>Device information</li>
            <li>Browser type</li>
            <li>Pages visited</li>
            <li>Time spent on the platform</li>
          </ul>
          <h3 className="mt-6 font-heading text-base font-semibold text-[#111827]">d. Cookies</h3>
          <p>
            Cookies help us improve your experience and analyze platform performance.
          </p>
        </section>
        <section>
          <h2>2. How we use your information</h2>
          <p>We use the information collected to:</p>
          <ul>
            <li>Create and manage your account</li>
            <li>Provide platform features</li>
            <li>Improve performance and user experience</li>
            <li>Send notifications or updates</li>
            <li>Prevent fraud and enhance security</li>
            <li>Offer customer support</li>
          </ul>
          <p>We do not sell your personal information to third parties.</p>
        </section>
        <section>
          <h2>3. How your information is shared</h2>
          <p>We may share information only in these cases:</p>
          <ul>
            <li>With service providers who help us operate the platform</li>
            <li>To comply with legal obligations</li>
            <li>To prevent fraud or misuse</li>
            <li>With your permission</li>
          </ul>
          <p>
            We do not share store data or customer data with advertisers or unrelated
            third parties.
          </p>
        </section>
        <section>
          <h2>4. Your customers&apos; information</h2>
          <p>
            If you collect information from your customers through your Sqaleshop store,
            you are responsible for handling that data according to applicable laws.
            Sqaleshop processes this information only to provide platform services.
          </p>
        </section>
        <section>
          <h2>5. Data security</h2>
          <p>
            We implement industry standard security measures to protect your data.
            However, no online platform can guarantee 100 percent security.
          </p>
        </section>
        <section>
          <h2>6. Data retention</h2>
          <p>
            We keep your information as long as your account is active or as necessary to
            provide services. You may request deletion of your data at any time.
          </p>
        </section>
        <section>
          <h2>7. Your rights</h2>
          <p>Depending on your region, you may have the right to:</p>
          <ul>
            <li>Access your data</li>
            <li>Request corrections</li>
            <li>Request deletion</li>
            <li>Withdraw consent</li>
            <li>Export your data</li>
          </ul>
          <p>You can contact us for any of these requests.</p>
        </section>
        <section>
          <h2>8. Children under 16</h2>
          <p>Sqaleshop does not knowingly collect information from children under 16.</p>
        </section>
        <section>
          <h2>9. Policy updates</h2>
          <p>
            We may update this Privacy Policy over time. Continued use of Sqaleshop
            means you agree to the updated policy.
          </p>
        </section>
        <section>
          <h2>10. Contact</h2>
          <p>
            For privacy concerns or questions:{" "}
            <a className="text-[#451892] hover:underline" href="mailto:support@sqaleshop.com">
              support@sqaleshop.com
            </a>
          </p>
        </section>
      </LegalProse>
    </MarketingPageShell>
  )
}
